import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMenuSummary = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "40px",
	height: "40px",
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
			d: "M23,3.83333333 C12.42,3.83333333 3.83333333,12.42 3.83333333,23 C3.83333333,33.58 12.42,42.1666667 23,42.1666667 C33.58,42.1666667 42.1666667,33.58 42.1666667,23 C42.1666667,12.42 33.58,3.83333333 23,3.83333333 Z M19.1666667,32.5833333 L9.58333333,23 L12.2858333,20.2975 L19.1666667,27.1591667 L33.7141667,12.6116667 L36.4166667,15.3333333 L19.1666667,32.5833333 Z",
			id: "path-1"
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Material-Design-Stickersheet",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "\\xDCbersicht-1",
				transform: "translate(-18.000000, -475.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Icon-/-Check-Circle-/-Filled-Copy",
					transform: "translate(15.000000, 472.000000)",
					children: [
						/* @__PURE__ */ _jsx("mask", {
							id: "mask-2",
							fill: "white",
							children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#path-1" })
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Mask",
							fillRule: "nonzero"
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group",
							mask: "url(#mask-2)",
							fill: "#FFFFFF",
							children: /* @__PURE__ */ _jsx("g", {
								id: "\\u21B3-Tonal-Palette",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle-13",
									x: 0,
									y: 0,
									width: 46,
									height: 46
								})
							})
						})
					]
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgIconMenuSummary);
export { ForwardRef as ReactComponent };
